import barSrc from '@/assets/svg/bar.svg';
import bathroomSrc from '@/assets/svg/bathroom.svg';
import exitSrc from '@/assets/svg/exit.svg';
import foodSrc from '@/assets/svg/food.svg';
import stageSrc from '@/assets/svg/stage.svg';
import accessibleSrc from '@/assets/svg/accessible.svg';
import pinSrc from '@/assets/svg/pin.svg';

export const PREDEFINED_TYPES = {
  BAR: 'bar',
  BATHROOM: 'bathroom',
  EXIT: 'exit',
  FOOD: 'food',
  STAGE: 'stage',
  ACCESSIBLE: 'accessible',
  PIN: 'pin',
};

export const DEFAULT_PREDEFINED = PREDEFINED_TYPES.BAR;

export const PREDEFINED_CONFIG = {
  bar: {
    id: 'bar',
    filename: barSrc,
    transform: {
      scale: 1.2,
    },
  },
  bathroom: {
    id: 'bathroom',
    filename: bathroomSrc,
    transform: {
      scale: 0.1,
    },
  },
  exit: {
    id: 'exit',
    filename: exitSrc,
    transform: {
      scale: 0.06,
    },
  },
  food: {
    id: 'food',
    filename: foodSrc,
    transform: {
      scale: 0.08,
    },
  },
  stage: {
    id: 'stage',
    filename: stageSrc,
    transform: {
      scale: 0.9,
    },
  },
  accessible: {
    id: 'accessible',
    filename: accessibleSrc,
    transform: {
      scale: 2,
    },
  },
  pin: {
    id: 'pin',
    filename: pinSrc,
    transform: {
      scale: 0.2,
    },
  },
};

function isTypeNotExist(type) {
  return PREDEFINED_CONFIG[type] === undefined;
}

export function getScale(type) {
  if (isTypeNotExist(type)) throw new Error(`Unknown type ${type}`);
  const { transform } = PREDEFINED_CONFIG[type];
  return transform.scale;
}

export function loadPredefinedUnit(type, svg) {
  if (isTypeNotExist(type)) throw new Error(`Unknown type ${type}`);
  const { transform, filename, id } = PREDEFINED_CONFIG[type];
  //const t = new Date().getTime();
  //const newFileName = `${filename}?${t}`;
  const object = svg.use(id, filename);
  object.transform(transform);
  return object;
}
